import { render } from "./ModalError.vue?vue&type=template&id=3c949fe6&scoped=true&ts=true"
import script from "./ModalError.vue?vue&type=script&lang=ts"
export * from "./ModalError.vue?vue&type=script&lang=ts"

import "./ModalError.vue?vue&type=style&index=0&id=3c949fe6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c949fe6"]])

export default __exports__